module.exports = __webpack_public_path__ + "img/ai.884d11db.png";